import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import styled from "styled-components";

import Textfield from "../components/Textfield";

import { toast } from "react-toastify";
import { Colors } from "../ColorConstants";
import { Text } from "../TextConstants";
import Button from "../components/Buttons";
import CustomLoader from "../components/Loader";
import ToastMessage from "../components/ToastMessage";
import { Validation, ValidationGuest } from "../helper";
import { userLogin } from "../services/userServices";

import OtpModal from "../components/CustomOtpModal";
import { EVENT } from "../analytics/constants";
import { trackFBEvent } from "../analytics";
const loginBg = require("../assets/images/Loginbg.png");

const Login = () => {
  let navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [pin, setPin] = useState("");
  const [error, setError] = useState({
    email: "",
    pin: "",
  });
  const [errorGuest, setErrorGuest] = useState({
    name: "",
    email: "",
  });
  const [name, setName] = useState("");
  const [guest, setGuest] = useState(false);
  const [loading, setLoading] = useState(false);

  const [loginModal, setLoginModal] = useState(true);
  // const [forgotPasswordModal, setForgotPasswordModal] = useState(false);
  const [otpCustomModal, setOtpCustomModal] = useState(false);

  const handleSubmit = (e) => {
    e?.preventDefault();
    let user;
    user = { email: email, pin: pin };
    const isValid = Validation(user, setError);
    if (isValid) {
      postLoginData(user);
    }
  };

  useEffect(() => {
    trackFBEvent(EVENT.CURRENT_SCREEN, { page: "Login Page" });
  }, []);

  const handleGuestCheckout = (e) => {
    e.preventDefault();
    if (guest) {
      const guestUser = { name, email };
      const isValid = ValidationGuest(guestUser, setErrorGuest);
      if (isValid) {
        setGuest(!guest);
        // localStorage.setItem("guest", JSON.stringify(!guest));
        navigate("/auth/home");
      }
    }
  };

  const postLoginData = async (user) => {
    setLoading(true);
    try {
      const response = await userLogin(user);
      if (response.status === 200) {
        trackFBEvent(EVENT.LOGIN, {
          email: user.email,
          user: response.data.name,
        });
        console.log("response", response);
        localStorage.setItem("token", response.data.token);
        localStorage.setItem("type", response.data.type);
        localStorage.removeItem("guestId");
        localStorage.setItem("name", response.data.name);
        localStorage.setItem("refreshToken", response.data.refreshToken);
        // localStorage.setItem("name", response.data.name);
        // localStorage.setItem("email", response.data.name);
        // toast.success(response.data.message, { hideProgressBar: false });
        navigate("/auth/home", { state: { name: response.data.name } });
      }
    } catch (error) {
      if (navigator.onLine) {
        toast.error(error.message, { hideProgressBar: true });
      } else {
        toast.error(
          <ToastMessage
            message="You're offline now"
            subMessage="Oops! Internet is disconnected."
          />,
          {
            hideProgressBar: true,
          }
        );
      }
    }
    setLoading(false);
  };

  return (
    <LoginStyled>
      {loginModal && (
        <LoginModal>
          <InnerDiv>
            <Logo src={require("../assets/images/lww_logo.png")} alt="logo" />
            <HeaderRight>
              {guest ? Text.guestHeader : Text.loginHeader}
            </HeaderRight>
            <SubHeaderRight>
              {guest ? Text.guestSubHeader : Text.loginSubHeader}
            </SubHeaderRight>
            {loading ? (
              <CustomLoader />
            ) : !guest ? (
              <LoginForm>
                <Textfield
                  placeholder={Text.loginEmailPlaceholder}
                  variant="Email id"
                  value={email}
                  size="large"
                  isRounded={true}
                  error={!!error.email}
                  onChange={(e) => {
                    setError((prevState) => {
                      return { ...prevState, email: "" };
                    });
                    setEmail(e.target.value);
                  }}
                  type="text"
                  color={Colors.secondaryBlack}
                  placeholderColor={Colors.santasGray}
                />
                {error.email && <ErrorMessage>{error.email}</ErrorMessage>}
                <TextFieldSpace>
                  <Textfield
                    placeholder={Text.loginPasswordPlaceholder}
                    variant="Password"
                    value={pin}
                    size="large"
                    isRounded={true}
                    error={!!error.pin}
                    onChange={(e) => {
                      setError((prevState) => {
                        return { ...prevState, pin: "" };
                      });
                      setPin(e.target.value);
                    }}
                    type="password"
                    textColor={Colors.secondaryBlack}
                    placeholderColor={Colors.santasGray}
                    onKeyPress={(e) => {
                      if (e.keyCode === 13) {
                        handleSubmit(e);
                      }
                    }}
                  />
                  {error.pin && <ErrorMessage>{error.pin}</ErrorMessage>}
                </TextFieldSpace>
                <ForgotPasswordText

                // onClick={() => setForgotPasswordModal(true)}
                >
                  <span onClick={() => navigate("/auth/forgotPassword")}>
                    {Text.loginForgotPassword}
                  </span>
                </ForgotPasswordText>
                <AddSpace>
                  <Button
                    label="Sign in"
                    variant="filled"
                    color={Colors.aqua}
                    size="large"
                    onClick={(e) => handleSubmit(e)}
                  />
                </AddSpace>
                <Button
                  label="Contiue as Guest"
                  outlineColor={Colors.aqua}
                  size="large"
                  onClick={(e) => {
                    navigate("/auth/home");
                    // setGuest(!guest);
                    // localStorage.setItem("guest", JSON.stringify(!guest));
                  }}
                />
              </LoginForm>
            ) : (
              <LoginForm>
                <>
                  <Textfield
                    placeholder={Text.signUpName}
                    variant="Name"
                    value={name}
                    size="large"
                    isRounded={true}
                    error={!!errorGuest.name}
                    onChange={(e) => {
                      setErrorGuest((prevState) => {
                        return { ...prevState, name: "" };
                      });
                      setName(e.target.value);
                    }}
                    type="text"
                    color={Colors.secondaryBlack}
                    placeholderColor={Colors.santasGray}
                  />

                  {errorGuest.name && (
                    <ErrorMessage>{errorGuest.name}</ErrorMessage>
                  )}
                </>
                <TextFieldSpace>
                  <Textfield
                    placeholder={Text.loginEmailPlaceholder}
                    variant="Email id"
                    value={email}
                    size="large"
                    isRounded={true}
                    error={!!errorGuest.email}
                    onChange={(e) => {
                      setErrorGuest((prevState) => {
                        return { ...prevState, email: "" };
                      });
                      setEmail(e.target.value);
                    }}
                    type="text"
                    color={Colors.secondaryBlack}
                    placeholderColor={Colors.santasGray}
                  />
                  {errorGuest.email && (
                    <ErrorMessage>{errorGuest.email}</ErrorMessage>
                  )}
                </TextFieldSpace>
                <AddSpace>
                  <Button
                    label="Checkout"
                    variant="filled"
                    color={Colors.aqua}
                    size="large"
                    onClick={(e) => handleGuestCheckout(e)}
                  />
                </AddSpace>
                <Button
                  label="Have an account? Sign in"
                  variant="outlined"
                  outlineColor={Colors.aqua}
                  size="large"
                  onClick={(e) => {
                    navigate("/auth/signup");
                    // setGuest(!guest);
                    // localStorage.setItem("guest", JSON.stringify(!guest));
                  }}
                />
              </LoginForm>
            )}
            <RegisterText>
              <span>{Text.noAccount}</span>{" "}
              <span onClick={() => navigate("/auth/signup")}>
                {Text.signUp}
              </span>
            </RegisterText>
          </InnerDiv>
        </LoginModal>
      )}
      {/* {forgotPasswordModal && <ForgotPassword />} */}
      {otpCustomModal && (
        <OtpModal
          success={true}
          otpText={Text.success}
          otpDetailText={Text.otpSuccessText}
          buttonLabel={Text.continue}
        />
      )}
    </LoginStyled>
  );
};

export default Login;

const LoginStyled = styled.div`
  height: 100vh;
  display: flex;
  justify-content: center;
  align-items: center;
  /* background-image: url(${loginBg}); */
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
`;
const LoginModal = styled.div`
  width: 31.7rem;
  // height: 36.3rem;
  border-radius: 0.5rem;
  background: ${Colors.whiteSmoke};
  @media only screen and (max-width: 768px) {
    width: 100vw;
    height: 100vh;
    border-radius: 0;
    display: flex;
    justify-content: center;
  }
`;
const InnerDiv = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
`;
const Logo = styled.img`
  width: 22rem;
  resize: contain;
  @media only screen and (max-width: 768px) {
    margin: 2rem 0;
  }
`;
const HeaderRight = styled.div`
  font-family: "Poppins";
  font-size: 1.5rem;
  color: ${Colors.black};
  margin-top: 1.2rem;
  font-weight: 600;
`;
const SubHeaderRight = styled.div`
  font-family: "Poppins";
  font-size: 0.875rem;
  color: ${Colors.black};
  margin-bottom: 2rem;
`;
const LoginForm = styled.form`
  width: 20rem;
  display: flex;
  flex-direction: column;
`;
const ErrorMessage = styled.div`
  font-family: "Poppins";
  font-size: 0.75rem;
  color: ${Colors.coralRedApprox};
  margin-top: 0.25rem;
`;

const RegisterText = styled.div`
  font-family: "Poppins";
  font-size: 0.875rem;
  margin-top: 1rem;
  margin-bottom: 1.5rem;

  span:first-child {
    color: ${Colors.black};
  }

  span:last-child {
    color: ${Colors.aqua};
    cursor: pointer;
    text-decoration: underline;
  }
`;

const ForgotPasswordText = styled.span`
  font-family: "Poppins";
  font-size: 0.875rem;
  color: ${Colors.black};
  text-align: right;
  text-decoration: underline;
  margin-top: 1rem;
  > span {
    cursor: pointer;
  }
`;
const AddSpace = styled.span`
  margin-top: 3rem;
  margin-bottom: 1rem;
`;

const TextFieldSpace = styled.span`
  margin-top: 1rem;
`;
